import getErrorResponse from "@/mixins/getResponseData";
import MiddlewareService from "@/MiddlewareService";
import constants from "@/store/admin/constants/admin";
import { SiteModules } from "@/helpers/Constants";

export default {
  mixins: [getErrorResponse, MiddlewareService],
  computed: {
    module() {
      const param = this.$route.path[this.$route.path.length - 1];
      return param === SiteModules.meetingRoom ? 'meetingroom' : '';
    }
  },
  methods: {
    /**
     * * Send request to API to get current site details
     *  @param {string|optional} id. Current site Id
     */
    async getSiteById(id = this.$route.params.serviceId, module, { includePages = false } = {}) {
      let url = `/Sites/${id}`;
      const params = [];
      if (module) params.push(`module=${module}`);
      if (includePages) params.push('includePages=true');
      if (params.length) url += `?${params.join('&')}`;
      const data = await this.processRequest(url);
      if (data?.body?.success) {
        await this.$store.dispatch(constants.setSite, data.body.message);
        if (includePages) return data.body.pages || [];
      } else {
        this.$awn.alert(this.getErrorResponse(data));
      }
      return null;
    },
    /**
     * Send request to API to save site
     * @param {Object} model Site model
     * @return {boolean} Returns true if success, otherwise null
     */
    async saveSite(model) {
      const data = await this.processRequest("/Sites/Save", "post", model);
      if (!data?.ok || data.body?.success === false) {
        let err = this.getErrorResponse(data);
        if (typeof err !== 'string') err = (err && typeof err === 'object') ? (err.message || err.title || JSON.stringify(err)) : String(err || 'Save failed');
        this.$awn.alert(err);
        return null;
      }
      return true;
    },
    async getCompanySitesList() {
      const data = await this.processRequest(`/Sites/List?modules=${this.module}`);
      if (data.ok) {
        await this.$store.dispatch(constants.setSites, data.body);
      } else {
        this.$awn.alert(this.getErrorResponse(data));
      }
    },

    /**
     * * Send request to API to get site details for client
     * *  @param {string|optional} siteId. Current site Id
     */
    async getClientSiteDetails(siteId = this.$route.params.siteId, module = false, code = '') {
      let url = `/Sites/${siteId}/client`;
      let add = '?';
      if (module) {
        url += `${add}module=${module}`; add = '&';
      }
      if (code) {
        url += `${add}code=${code}`; add = '&';
      }
      const data = await this.processRequest(url);
      const site = data.body?.message;
      if (!site) return;
      if (data.body.company) {
        this.$store.commit('token', data.body.company.token);
        localStorage.token = sessionStorage.token = data.body.company.token.bearer;
        delete data.body.company.token;
        this.$store.commit('company', data.body.company);
      }
      if (this.$route.params.employeeId && data.body.actionResult) data.body.actionResult.eEmail = this.$route.params.employeeId;
      for (const x of Object.entries(data.body)) {
        if (x[0] !== 'message' && x[0] !== 'company') this.$store.commit(x[0], x[1]);
      }
      if (site.width) {
        site.siteHeight = site.height;
        site.siteWidth = site.width;
        for (const page of site.sitePages) {
          for (const pc of page.pageComponents) {
            pc.pageComponentContents = pc.componentContents;
            pc.properties = JSON.parse(pc.properties);
            pc.styles = JSON.parse(pc.styles);
          }
        }
      }
      this.$store.commit(constants.setSite, site);
      return site;
    },
  }
};
